import { CompanyUserClass } from '@vedicium/core-vue/build/modules/company';

export default class User extends CompanyUserClass {
  static uri = '/v2/users';
}
